export default __webpack_public_path__ + "static/women-27f8fd18980ff742efae08f5001eb137.png";